var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn navbar-btn btn-link ms-3 px-1",attrs:{"data-bs-target":"#modalNavigation","data-bs-toggle":"modal","type":"button"}},[_c('font-awesome-icon',{staticStyle:{"font-size":"2rem"},attrs:{"icon":"fa-solid fa-bars"}}),_c('span',{staticClass:"sr-only"},[_vm._v("Открыть меню")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }